import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import fr from 'facet-rest';
import { closeSchedulerModal, useClientSchedulerStateContext } from 'Context/NewClientSchedulerContext';
import RescheduleMeeting from 'Components/UI/MeetingCard/Combined/RescheduleMeeting';
import history from 'State/history';
import { dashboardUri } from 'Consts/clientUris';
import UnableToSchedule from './UnableToSchedule';
import MeetingBooked from './MeetingBooked';
import RescheduleLinkExpired from './RescheduleLinkExpired';
import MonthlyCalendar from './MonthlyCalendar';
import ConfirmTime from './ConfirmTime';

const styles = () => ({
  spinnerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },
  spinner: {
    height: '100%',
    width: '100%',
  },
});

const ViewContainer = ({ classes }) => {
  const { view, loading, currentCollection } = useClientSchedulerStateContext();

  if (loading) {
    return (
      <div className={classes.spinnerContainer}>
        <CircularProgress className={classes.spinner} />
      </div>
    );
  }

  // Get the availability period resource for relationship rendering
  const availabilityPeriodResource = currentCollection?.resources()?.head();
  const handleReturnToDashboard = () => {
    closeSchedulerModal();
    history.push(dashboardUri);
  };

  switch (view) {
    case 'autoChiliPiper':
      // Auto-trigger ChiliPiper dialog when rescheduleCalendarEventId is present
      return availabilityPeriodResource?.withRelationship(
        fr.relationships.chilipiperRescheduleLink.name,
        (rel) => (
          <RescheduleMeeting
            relationship={rel}
            meetingResource={availabilityPeriodResource}
            refreshMeetings={handleReturnToDashboard}
            autoOpen
          />
        ),
        () => <MonthlyCalendar />,
      );
    case 'meetingBooked':
      return (
        <MeetingBooked />
      );
    case 'confirmTime':
      return (
        <ConfirmTime />
      );
    case 'meetingExpired':
      return (
        <RescheduleLinkExpired />
      );
    case 'month':
      return (
        <MonthlyCalendar />
      );
    case 'unableToSchedule':
      return <UnableToSchedule />;
    case 'error':
      return <UnableToSchedule />;
    default:
      return null;
  }
};

export default withStyles(styles)(ViewContainer);
